import type { PermissionCode } from '@/shared/permissions';

/**
 * Inventory permission codes — mirror the BFF's `RolePermissionMapper`:
 *  - `inventory.view` — stock list, per-product stock, movement ledger, alerts, policy GET
 *  - `inventory.manage` — receipts, adjustments, transfers, policy PUT
 *
 * These are a DIFFERENT namespace than the pre-existing `settings.inventory.view` /
 * `settings.inventory.manage` codes, which gate the separate, generic tenant-wide tracking/
 * reservation-policy settings stub (`store-settings/ui/pages/InventorySettingsPage.tsx`).
 * `settings.*` does NOT grant these — the BFF's RolePermissionMapper grants them as their own
 * bare `inventory.*` namespace, deliberately distinct (see its own inline comment).
 */
export const INVENTORY_PERMISSIONS = {
  view: 'inventory.view',
  manage: 'inventory.manage',
} as const satisfies Record<string, PermissionCode>;

/** Flattened list of every inventory permission code (for mock sessions / seeding). */
export const ALL_INVENTORY_PERMISSIONS: PermissionCode[] = Object.values(INVENTORY_PERMISSIONS);
